import Modal from "react-responsive-modal";
import React from "react";
import { PDFPreview } from "@public/ui-toolkit";

const DocumentModal = ({ src, open,onClose, modalSize = "650px" ,fileType="pdf" }) => {
  return (
    <Modal open={open} onClose={onClose} center
    classNames={{
     modal: 'react-modal',
   }}
   styles={{maxWidth :  modalSize}}
   closeIcon={<></>}>
      <PDFPreview
        src={src}
        minHeight= {"90vh"}
        title="pdf-preview"
      />
      {/* //<DocViewer
      //   pluginRenderers={DocViewerRenderers}
      //   documents={docs}
      //   config={{
      //     header: {
      //       disableHeader: true,
      //       disableFileName: true,
      //       retainURLParams: false,
      //     },
      //   }}
      // /> */}
    </Modal>
  );
};

export default DocumentModal;
